export const billingModeId = {
	periodically: "1",
	quota: "2",
} as const;

export type BillingModeId = typeof billingModeId[keyof typeof billingModeId];